export default "__VITE_ASSET__D4kU9hz$__"